// The canonical index of GymBeam Magento store codes, shared by the API and the
// dashboard. Only the *list* lives here: every per-store attribute (storeId,
// domain, locale, country, eligibility) is declared in `apps/api/data/stores/<code>.json`
// and loaded by `apps/api/src/modules/integrations/magento/stores.ts`, which
// re-exports this list so there is exactly one place a new store is added.
//
// The dashboard needs the list without the API's Node-only loader — a store
// picker offers every store, so duplicating the codes in web would drift the
// moment a market is added.

export const STORE_CODES = [
  "gymbeamat",
  "gymbeamit",
  "gymbeamfr",
  "gymbeamsk",
  "gymbeamnl",
  "gymbeamde",
  "gymbeamcz",
  "gymbeamro",
  "gymbeampl",
  "gymbeamhu",
  "gymbeamcom",
  "gymbeamhr",
  "gymbeambg",
  "gymbeamsi",
  "gymbeamrs",
  "gymbeamgr",
  "gymbeames",
] as const satisfies readonly string[]

export type StoreCode = (typeof STORE_CODES)[number]

/** Default store for catalog browsing and the product page's visuals gallery.
 *  Both URL-backed controls fall back to this value when `store` is omitted or
 *  invalid, so the two product surfaces open on the same catalog. */
export const CATALOG_INDEX_STORE = "gymbeamde" satisfies StoreCode
